import React, { useState } from "react";
import "./checkin-flights.css";
import Swal from "sweetalert2";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

function CheckInFlights() {
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2019 + 1 },
    (_, i) => 2019 + i
  );

  const [year, setYear] = useState(currentYear);
  const [flightNumber, setFlightNumber] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [noResults, setNoResults] = useState(false); // <-- NUEVO

  // Fuente única de datos (para filtrar y para "Todo") <-- NUEVO
  const ALL_DUMMY_DATA = [
    {
      vuelo: "AM1234/12AUG",
      año: 2025,
      origen: "MEX",
      destino: "JFK",
      guias: 12,
      piezas: 34,
      peso: "567.80",
    },
    {
      vuelo: "AM4321/14AUG",
      año: 2025,
      origen: "GDL",
      destino: "LAX",
      guias: 7,
      piezas: 15,
      peso: "238.45",
    },
    {
      vuelo: "AM0012/28SEP",
      año: 2025,
      origen: "MTY",
      destino: "MAD",
      guias: 1,
      piezas: 50,
      peso: "100.00",
    },
  ];

  const handleFlightChange = (e) => {
    const input = e.target.value;
    const formatted = formatFlight(input);
    setFlightNumber(formatted);
  };

  const formatFlight = (value) => {
    const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
    const match = value.toUpperCase().match(regex);
    if (!match) return value.toUpperCase();
    const [, airline, number, day, month] = match;
    const paddedNumber = number.padStart(4, "0");
    return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
  };

  // "Todo": limpia input y muestra todos los registros <-- AJUSTADO
  const handleShowAll = () => {
    setFlightNumber("");
    setTableData(ALL_DUMMY_DATA);
    setShowTable(true);
    setNoResults(false);
  };

  // "Aplicar": filtra por Vuelo (exacto) y Año <-- NUEVO
  const handleApply = () => {
    const filtered = ALL_DUMMY_DATA.filter(
      (item) =>
        item.vuelo.toUpperCase() === flightNumber.toUpperCase() &&
        item.año === year
    );
    if (filtered.length > 0) {
      setTableData(filtered);
      setShowTable(true);
      setNoResults(false);
    } else {
      setTableData([]);
      setShowTable(false);
      setNoResults(true);
    }
  };

  // --- TU checkInAlert ORIGINAL (SIN CAMBIOS) ---
  const checkInAlert = (vuelo, año) => {
    Swal.fire({
      title: "Check-In Vuelo",
      html: `
      <div style="text-align:left; font-size:14px;">

        <!-- Vuelo y Año -->
        <div style="display:flex; gap:20px; align-items:center;">
          <div><label><strong>Vuelo:</strong></label> <span>${vuelo}</span></div>
          <div><label><strong>Año:</strong></label> <span>${año}</span></div>
        </div>

        <hr class="hr-custom" style="margin:10px 0; margin-bottom: 20px;">

        <!-- ATA Fecha, Hora, Tipo avión -->
        <div style="display:flex; gap:20px;">
          <div style="flex:1;"><label><strong>ATA Fecha</strong></label><input id="ataFecha" type="date" class="form-control" style="width:100%;"></div>
          <div style="flex:1;"><label><strong>ATA Hora</strong></label><input id="ataHora" type="time" class="form-control" style="width:100%;"></div>
          <div style="flex:1;">
            <label><strong>Tipo de avión</strong></label>
            <select id="tipoAvion" class="form-select" style="width:100%;">
              <option value="">Seleccionar...</option>
              <option>Wide Body</option>
              <option>Narrow Body</option>
              <option>Charter</option>
            </select>
          </div>
        </div>

        <!-- Coordinador -->
        <div style="margin-top:10px; margin-bottom: 20px;">
          <label><strong>Coordinador</strong></label>
          <input id="coordinador" type="text" class="form-control" style="width:40%;">
        </div>

        <hr class="hr-custom" style="margin:10px 0;">

        <!-- Contenedor de bloques -->
        <div id="blocksContainer"></div>

        <!-- Botón circular con icono -->
        <div style="text-align:center; margin-bottom:10px;">
          <button id="addSectionBtn" style="background:#0E2240; border:none; border-radius:50%; padding:10px; cursor:pointer; color:white;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="20" height="20">
              <path d="M12 5v14m-7-7h14" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>

        <!-- Alerta de error -->
        <div id="errorAlert" style="display:none; margin-bottom:10px;">
          <div class="alert alert-danger" role="alert">
            Por favor llenar todos los campos.
          </div>
        </div>

        <!-- Botones finales -->
        <div style="display:flex; justify-content:flex-end; gap:10px; margin-top:10px;">
          <button id="cerrarBtn" type="button" class="btnn">Cerrar</button>
          <button id="guardarBtn" type="button" class="btnn">Guardar</button>
          <button type="button" class="btnn">Cerrar vuelo</button>
        </div>
      </div>
    `,
      showConfirmButton: false,
      width: "700px",
      customClass: { popup: "alert-bg", title: "alert-title" },
      didRender: () => {
        const addBtn = document.getElementById("addSectionBtn");
        const cerrarBtn = document.getElementById("cerrarBtn");
        const guardarBtn = document.getElementById("guardarBtn");
        const errorAlert = document.getElementById("errorAlert");

        const blocksContainer = document.getElementById("blocksContainer");
        let convoyCounter = 0;

        // Cerrar modal
        cerrarBtn.addEventListener("click", () => {
          Swal.close();
        });

        // Guardar datos con validación
        guardarBtn.addEventListener("click", () => {
          const ataFecha = document.getElementById("ataFecha").value.trim();
          const ataHora = document.getElementById("ataHora").value.trim();
          const tipoAvion = document.getElementById("tipoAvion").value.trim();
          const coordinador = document
            .getElementById("coordinador")
            .value.trim();

          if (!ataFecha || !ataHora || !tipoAvion || !coordinador) {
            errorAlert.style.display = "block";
          } else {
            errorAlert.style.display = "none";
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: "Los datos han sido guardados",
              confirmButtonText: "OK",
            }).then(() => {
              Swal.close();
            });
          }
        });

        // Botón para agregar bloques
        addBtn.addEventListener("click", () => {
          convoyCounter++;

          if (convoyCounter > 1) {
            const hr = document.createElement("hr");
            hr.className = "hr-custom";
            hr.style.margin = "10px 0";
            blocksContainer.appendChild(hr);
          }

          const newDiv = document.createElement("div");
          newDiv.style.cssText = `position: relative; padding: 15px; margin-bottom: 10px;`;

          const closeBtn = document.createElement("button");
          closeBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" width="16" height="16">
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.42L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        `;
          closeBtn.style.cssText = `
          position: absolute; top: 5px; right: 5px; background: #d43f3a; 
          color: white; border: none; border-radius: 50%; width: 28px; height: 28px;
          display: flex; align-items: center; justify-content: center; cursor: pointer;
        `;
          closeBtn.addEventListener("click", () => {
            const prev = newDiv.previousSibling;
            const next = newDiv.nextSibling;
            if (prev && prev.tagName === "HR") prev.remove();
            if (next && next.tagName === "HR") next.remove();
            newDiv.remove();
            if (blocksContainer.querySelectorAll("div").length === 0)
              convoyCounter = 0;
          });

          newDiv.innerHTML = `
          <h4 style="text-align:center; margin-bottom:10px;">Convoy ${convoyCounter}</h4>
          <div style="display:flex; gap:10px; margin-bottom:5px;">
            <label style="flex:1; text-align:center; font-weight:bold;">ULD</label>
            <label style="flex:1; text-align:center; font-weight:bold;">XP</label>
            <label style="flex:1; text-align:center; font-weight:bold;">PL</label>
          </div>
          <div style="display:flex; gap:10px; margin-bottom:10px;">
            <input type="number" class="form-control" style="flex:1;">
            <input type="number" class="form-control" style="flex:1;">
            <input type="number" class="form-control" style="flex:1;">
          </div>
          <div style="display:flex; gap:10px; margin-bottom:5px;">
            <label style="flex:1; text-align:center; font-weight:bold;">Tractorista</label>
            <label style="flex:1; text-align:center; font-weight:bold;">Fecha</label>
            <label style="flex:1; text-align:center; font-weight:bold;">Hora</label>
          </div>
          <div style="display:flex; gap:10px; margin-bottom:10px;">
            <input type="text" class="form-control" style="flex:1;">
            <input type="date" class="form-control" style="flex:1;">
            <input type="time" class="form-control" style="flex:1;">
          </div>
          <div style="margin-bottom:5px;">
            <label style="font-weight:bold;">Observaciones</label>
          </div>
          <div>
            <input type="text" class="form-control" style="width:40%;">
          </div>
        `;
          newDiv.insertBefore(closeBtn, newDiv.firstChild);
          blocksContainer.appendChild(newDiv);
        });
      },
    });
  };
  // --- FIN checkInAlert ORIGINAL ---

  return (
    <div className="container-fluid">
      <div className="row justify-content-center mb-4">
        <div className="col-12 col-md-8">
          <div className="row justify-content-center gy-3">
            <div className="col-md-5 text-center">
              <label className="form-label">Vuelo</label>
              <input
                type="text"
                className="form-control"
                value={flightNumber}
                onChange={handleFlightChange}
                maxLength={12}
              />
            </div>
            <div className="col-md-4 text-center">
              <label className="form-label">Año</label>
              <select
                className="form-select"
                value={year}
                onChange={(e) => setYear(parseInt(e.target.value))}
              >
                {years.map((yr) => (
                  <option key={yr} value={yr}>
                    {yr}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Botones */}
      <div className="row justify-content-center mb-3">
        <div className="col-auto text-center">
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <button className="btnn" onClick={handleApply}>
              Aplicar
            </button>
            <button className="btnn" onClick={handleShowAll}>
              Todo
            </button>
          </div>
        </div>
      </div>

      {/* Mensaje de no resultados */}
      {noResults && (
        <div className="alert alert-danger text-center">
          No se encontraron datos
        </div>
      )}

      {/* Tabla */}
      {showTable && tableData.length > 0 && (
        <div className="table-container">
          <table className="table fondo-headMilestones">
            <thead>
              <tr className="text-center">
                <th>Vuelo</th>
                <th>Año</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Guías</th>
                <th>Piezas</th>
                <th>Peso</th>
                <th>Check-in</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, idx) => (
                <tr key={idx} className="text-center align-middle">
                  <td>{row.vuelo}</td>
                  <td>{row.año}</td>
                  <td>{row.origen}</td>
                  <td>{row.destino}</td>
                  <td>{row.guias}</td>
                  <td>{row.piezas}</td>
                  <td>{row.peso}</td>
                  <td>
                    <button
                      className="btnn"
                      onClick={() => checkInAlert(row.vuelo, row.año)}
                    >
                      Check in
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CheckInFlights;
